import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { EnvironmentInterface } from '../../../types';
import {
    ActualAppVersionClient,
    VersionCheckRequest,
    VersionCheckResponse
} from '../domain/services/actual-app-version-client';

/**
 * Service for making HTTP calls to the backend for version checking
 */
@Injectable({
    providedIn: 'root'
})
export class BackendActualAppVersionClient extends ActualAppVersionClient {
    constructor(
        private http: HttpClient,
        @Inject('environment') private environment: EnvironmentInterface
    ) {
        super();
    }

    /**
     * Makes an HTTP call to check if the app needs to be updated
     * @param request The version check request
     * @returns An Observable that emits true if the app needs to be updated, false otherwise
     */
    checkVersion(request: VersionCheckRequest): Observable<boolean> {
        return this.http.post<VersionCheckResponse>(`${this.environment.apiUrl}/check-version`, request).pipe(
            map(response => response.requiresUpdate),
            catchError(() => {
                // If there's an error checking the version, assume no update is needed
                return of(false);
            })
        );
    }
}
